/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.3.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import moment from "moment";

export class ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Отправка кода верификации на телефон соискателя для регистрации.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendRegistrationVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-registration-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationVerificationCode(_response);
        });
    }

    protected processSendRegistrationVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации соискателя для регистрации.
     * @param body Данные для проверки.
     * @return Success
     */
    checkRegistrationVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-registration-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRegistrationVerificationCode(_response);
        });
    }

    protected processCheckRegistrationVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Регистрация нового соискателя.
     * @param body Данные для регистрации.
     * @return Соискатель успешно зарегистрирован.
     */
    register(body: RegisterApplicant): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0432\u0435\u0440\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон соискателя для сброса пароля.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendResetPasswordVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendResetPasswordVerificationCode(_response);
        });
    }

    protected processSendResetPasswordVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации соискателя для сброса пароля.
     * @param body Данные для проверки.
     * @return Success
     */
    checkResetPasswordVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckResetPasswordVerificationCode(_response);
        });
    }

    protected processCheckResetPasswordVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля существующего соискателя.
     * @param body Данные для сброса пароля.
     * @return OK
     */
    resetPassword(body: ResetPassword): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0432\u0435\u0440\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d \u0441\u043e\u0438\u0441\u043a\u0430\u0442\u0435\u043b\u044c \u0441 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u044b\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Смена пароля
     * @return Успешно.
     */
    changePassword(body: ChangePassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Вход соискателя.
     * @param body Данные для входа.
     * @return Соискатель успешно авторизован.
     */
    login(body: LoginApplicant): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0434\u0430\u043d\u043d\u044b\u0445.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043b\u043e\u0433\u0438\u043d /\u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Возвращает профиль авторизованного соискателя
     * @return Успешно.
     */
    profile(): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * Сохраняет изменения в профиле соискателя
     * @return Успешно.
     */
    updateProfile(body: UpdateProfile): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * Возвращает документ удостоверяющий личность соискателя
     * @return Успешно.
     */
    getIdentityDoc(): Promise<ApplicantIdentityDoc> {
        let url_ = this.baseUrl + "/api/v1/account/identity-doc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentityDoc(_response);
        });
    }

    protected processGetIdentityDoc(response: Response): Promise<ApplicantIdentityDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantIdentityDoc.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantIdentityDoc>(<any>null);
    }

    /**
     * Устанавливает в качестве документа удостоверяющего личность паспорт соискателя
     * @return Успешно.
     */
    setApplicantPassport(body: SetApplicantPassport): Promise<ApplicantIdentityDoc> {
        let url_ = this.baseUrl + "/api/v1/account/identity-doc/passport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetApplicantPassport(_response);
        });
    }

    protected processSetApplicantPassport(response: Response): Promise<ApplicantIdentityDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantIdentityDoc.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantIdentityDoc>(<any>null);
    }

    /**
     * Устанавливает в качестве документа удостоверяющего личность другой документ соискателя
     * @return Успешно.
     */
    setApplicantOtherIdentity(body: SetApplicantOtherIdentity): Promise<ApplicantIdentityDoc> {
        let url_ = this.baseUrl + "/api/v1/account/identity-doc/other";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetApplicantOtherIdentity(_response);
        });
    }

    protected processSetApplicantOtherIdentity(response: Response): Promise<ApplicantIdentityDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantIdentityDoc.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantIdentityDoc>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон соискателя для изменения номера.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendUpdatePhoneVerificationCode(body: SendVerificationCodeForUpdatePhone): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendUpdatePhoneVerificationCode(_response);
        });
    }

    protected processSendUpdatePhoneVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации соискателя для изменения номера.
     * @param body Данные для проверки.
     * @return Success
     */
    checkUpdatePhoneVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUpdatePhoneVerificationCode(_response);
        });
    }

    protected processCheckUpdatePhoneVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сохраняет изменения в профиле соискателя
     * @param body (optional) 
     * @return Успешно.
     */
    updatePhone(body: UpdatePhone | undefined): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/account/update-phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * Возвращает состояние событий
     * @return Успешно.
     */
    getEventsState(): Promise<EventsStateHolder> {
        let url_ = this.baseUrl + "/api/v1/account/events-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventsState(_response);
        });
    }

    protected processGetEventsState(response: Response): Promise<EventsStateHolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventsStateHolder.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventsStateHolder>(<any>null);
    }

    /**
     * @return Success
     */
    getCaptcha(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptcha(_response);
        });
    }

    protected processGetCaptcha(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Подтверждение электронной почты
     * @param body (optional) 
     * @return Success
     */
    confirmEmailByToken(body: ConfirmEmailByToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmailByToken(_response);
        });
    }

    protected processConfirmEmailByToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Повторная отправка подтверждающего письма на почту
     * @param body (optional) 
     * @return Success
     */
    sendConfirmationEmailAgain(body: SendConfirmationEmailAgain | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-email-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendConfirmationEmailAgain(_response);
        });
    }

    protected processSendConfirmationEmailAgain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Создаёт заявку на прохождение экзамена
     * @return Success
     */
    createExamApplication(body: CreateExamApplication): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExamApplication(_response);
        });
    }

    protected processCreateExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamApplicationsList(examReviewStatus: ExamReviewStatus, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | undefined, sortField: string | undefined): Promise<ApplicantExamList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications?";
        if (examReviewStatus === undefined || examReviewStatus === null)
            throw new Error("The parameter 'examReviewStatus' must be defined and cannot be null.");
        else
            url_ += "examReviewStatus=" + encodeURIComponent("" + examReviewStatus) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplicationsList(_response);
        });
    }

    protected processGetExamApplicationsList(response: Response): Promise<ApplicantExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamList>(<any>null);
    }

    /**
     * Отправляет код для подписи заявки
     * @param examApplicationId Идентификатор заявки
     * @return Success
     */
    sendCodeToSignApplication(examApplicationId: string, body: SendCodeToSignApplication): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/send-code-to-sign";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeToSignApplication(_response);
        });
    }

    protected processSendCodeToSignApplication(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Отправляет заявку на рассмотрение
     * @param examApplicationId Идентификатор заявки
     * @param body (optional) 
     * @return Success
     */
    submitExamApplication(examApplicationId: string, body: SubmitExamApplication | undefined): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/submit";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitExamApplication(_response);
        });
    }

    protected processSubmitExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getMyExamApplicationsList(myExamStatus: MyExamStatus, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | undefined, sortField: string | undefined): Promise<ApplicantExamList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/my?";
        if (myExamStatus === undefined || myExamStatus === null)
            throw new Error("The parameter 'myExamStatus' must be defined and cannot be null.");
        else
            url_ += "myExamStatus=" + encodeURIComponent("" + myExamStatus) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyExamApplicationsList(_response);
        });
    }

    protected processGetMyExamApplicationsList(response: Response): Promise<ApplicantExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamList>(<any>null);
    }

    /**
     * @return Success
     */
    getExamApplication(examApplicationId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplication(_response);
        });
    }

    protected processGetExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentTemplateGroups(qualificationId: string): Promise<QualificationDocumentTemplateGroup[]> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/document-template-groups/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentTemplateGroups(_response);
        });
    }

    protected processGetDocumentTemplateGroups(response: Response): Promise<QualificationDocumentTemplateGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationDocumentTemplateGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationDocumentTemplateGroup[]>(<any>null);
    }

    /**
     * Позволяет загрузить файл для выбранного комплекта документов заявки
     * @param examApplicationId Идентификатор заявки
     * @param templateId Id шаблона из комплекта документов
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    uploadExamApplicationDocument(examApplicationId: string, templateId: string, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/documents/{templateId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadExamApplicationDocument(_response);
        });
    }

    protected processUploadExamApplicationDocument(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * Позволяет удалить файл документа из комплекта документов заявки
     * @param examApplicationId Идентификатор заявки
     * @param documentId Id шаблона из комплекта документов
     * @return Success
     */
    deleteExamApplicationDocument(examApplicationId: string, documentId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/documents/{documentId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExamApplicationDocument(_response);
        });
    }

    protected processDeleteExamApplicationDocument(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * Позволяет удалить дополнительный файл документа выбранного комплекта
     * @param examApplicationId Идентификатор заявки
     * @param documentId Идентификатор шаблона из комплекта документов
     * @param sourceFileId Идентификатор дополнительного файла
     * @return Success
     */
    deleteExamApplicationDocumentSource(examApplicationId: string, documentId: string, sourceFileId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/documents/{documentId}/source/{sourceFileId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExamApplicationDocumentSource(_response);
        });
    }

    protected processDeleteExamApplicationDocumentSource(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * Получение расписания экзаменов
     * @param from (optional) Дата экзамена, с
     * @param to (optional) Дата экзамена, по
     * @param examType (optional) 
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExams(from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, examType: ExamType | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ApplicantExamList> {
        let url_ = this.baseUrl + "/api/v1/exams?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (examType === null)
            throw new Error("The parameter 'examType' cannot be null.");
        else if (examType !== undefined)
            url_ += "examType=" + encodeURIComponent("" + examType) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExams(_response);
        });
    }

    protected processGetExams(response: Response): Promise<ApplicantExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamList>(<any>null);
    }

    /**
     * Получение информации по экзамену
     * @param id ид экзамена
     * @return Success
     */
    getExamDetails(id: string): Promise<ApplicantExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamDetails(_response);
        });
    }

    protected processGetExamDetails(response: Response): Promise<ApplicantExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamDetails>(<any>null);
    }

    /**
     * Генерация ключа для перехода в кабинет проведения онлайн экзамена
     * @param id ид экзамена
     * @return Success
     */
    generateOnlineExamRedirectionUrl(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/exams/{id}/online-exam-redirection-url";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateOnlineExamRedirectionUrl(_response);
        });
    }

    protected processGenerateOnlineExamRedirectionUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Формирует ссылку на оплату экзамена
     * @return Success
     */
    generatePaymentUrl(body: GeneratePaymentUrl): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/payment/generate-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneratePaymentUrl(_response);
        });
    }

    protected processGeneratePaymentUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Возвращает список квалификаций соискателя.
     * @return OK
     */
    getQualifications(): Promise<ApplicantQualification[]> {
        let url_ = this.baseUrl + "/api/v1/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: Response): Promise<ApplicantQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicantQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualification[]>(<any>null);
    }

    /**
     * Возвращает детали квалификаций соискателя.
     * @return OK
     */
    getQualificationDetails(examApplicationId: string): Promise<ApplicantQualificationDetails> {
        let url_ = this.baseUrl + "/api/v1/qualifications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualificationDetails(_response);
        });
    }

    protected processGetQualificationDetails(response: Response): Promise<ApplicantQualificationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantQualificationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualificationDetails>(<any>null);
    }
}

export class ApiError implements IApiError {
    code!: number;
    type!: AppExceptionType;
    message!: string;
    failures?: { [key: string]: string[]; } | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.message = _data["message"];
            if (_data["failures"]) {
                this.failures = {} as any;
                for (let key in _data["failures"]) {
                    if (_data["failures"].hasOwnProperty(key))
                        (<any>this.failures)![key] = _data["failures"][key] !== undefined ? _data["failures"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["message"] = this.message;
        if (this.failures) {
            data["failures"] = {};
            for (let key in this.failures) {
                if (this.failures.hasOwnProperty(key))
                    (<any>data["failures"])[key] = this.failures[key];
            }
        }
        return data; 
    }
}

export interface IApiError {
    code: number;
    type: AppExceptionType;
    message: string;
    failures?: { [key: string]: string[]; } | undefined;
}

export enum AppExceptionType {
    Unspecified = "unspecified",
    Validation = "validation",
    NotFound = "notFound",
    AlreadyExists = "alreadyExists",
    WrongVerificationCode = "wrongVerificationCode",
    TooManyRequests = "tooManyRequests",
    WrongCredentials = "wrongCredentials",
    AuthUserNotFound = "authUserNotFound",
    Forbidden = "forbidden",
    Captcha = "captcha",
    WrongIp = "wrongIp",
}

export class Applicant implements IApplicant {
    id!: string;
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName?: string | undefined;
    sex!: Sex;
    birthDate!: moment.Moment;
    email!: string;
    emailConfirmed!: boolean;
    phone!: string;
    isExpert!: boolean;

    constructor(data?: IApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phone = _data["phone"];
            this.isExpert = _data["isExpert"];
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phone"] = this.phone;
        data["isExpert"] = this.isExpert;
        return data; 
    }
}

export interface IApplicant {
    id: string;
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName?: string | undefined;
    sex: Sex;
    birthDate: moment.Moment;
    email: string;
    emailConfirmed: boolean;
    phone: string;
    isExpert: boolean;
}

export class ApplicantExam implements IApplicantExam {
    examId!: string;
    date!: moment.Moment;
    duration!: number;
    reviewComment?: string | undefined;
    examPrice!: number;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    examinationCenterName!: string;
    address!: string;
    qualificationEvaluationCenterName!: string;
    city!: string;
    examStatus!: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification!: boolean;
    examType!: ExamType;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;

    constructor(data?: IApplicantExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.reviewComment = _data["reviewComment"];
            this.examPrice = _data["examPrice"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.city = _data["city"];
            this.examStatus = _data["examStatus"];
            this.recertification = _data["recertification"];
            this.examType = _data["examType"];
            this.processedByNark = _data["processedByNark"];
            this.examApplicationStatus = _data["examApplicationStatus"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
        }
    }

    static fromJS(data: any): ApplicantExam {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["reviewComment"] = this.reviewComment;
        data["examPrice"] = this.examPrice;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["city"] = this.city;
        data["examStatus"] = this.examStatus;
        data["recertification"] = this.recertification;
        data["examType"] = this.examType;
        data["processedByNark"] = this.processedByNark;
        data["examApplicationStatus"] = this.examApplicationStatus;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        return data; 
    }
}

export interface IApplicantExam {
    examId: string;
    date: moment.Moment;
    duration: number;
    reviewComment?: string | undefined;
    examPrice: number;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    examinationCenterName: string;
    address: string;
    qualificationEvaluationCenterName: string;
    city: string;
    examStatus: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification: boolean;
    examType: ExamType;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
}

export class ApplicantExamDetails implements IApplicantExamDetails {
    examId!: string;
    date!: moment.Moment;
    duration!: number;
    reviewComment?: string | undefined;
    examPrice!: number;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    examinationCenterName!: string;
    address!: string;
    qualificationEvaluationCenterName!: string;
    city!: string;
    examStatus!: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification!: boolean;
    examType!: ExamType;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
    practicalPartDuration!: number;
    practicalQuestionsCount!: number;
    theoreticalPartDuration!: number;
    theoreticalQuestionsCount!: number;
    rules?: string | undefined;
    isPassedTheory?: boolean | undefined;
    finalized!: boolean;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts!: ExamExpert[];
    statusChangeTime!: moment.Moment;

    constructor(data?: IApplicantExamDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.reviewComment = _data["reviewComment"];
            this.examPrice = _data["examPrice"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.city = _data["city"];
            this.examStatus = _data["examStatus"];
            this.recertification = _data["recertification"];
            this.examType = _data["examType"];
            this.processedByNark = _data["processedByNark"];
            this.examApplicationStatus = _data["examApplicationStatus"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            this.practicalQuestionsCount = _data["practicalQuestionsCount"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.theoreticalQuestionsCount = _data["theoreticalQuestionsCount"];
            this.rules = _data["rules"];
            this.isPassedTheory = _data["isPassedTheory"];
            this.finalized = _data["finalized"];
            if (Array.isArray(_data["experts"])) {
                this.experts = [] as any;
                for (let item of _data["experts"])
                    this.experts!.push(ExamExpert.fromJS(item));
            }
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExamDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["reviewComment"] = this.reviewComment;
        data["examPrice"] = this.examPrice;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["city"] = this.city;
        data["examStatus"] = this.examStatus;
        data["recertification"] = this.recertification;
        data["examType"] = this.examType;
        data["processedByNark"] = this.processedByNark;
        data["examApplicationStatus"] = this.examApplicationStatus;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["practicalQuestionsCount"] = this.practicalQuestionsCount;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["theoreticalQuestionsCount"] = this.theoreticalQuestionsCount;
        data["rules"] = this.rules;
        data["isPassedTheory"] = this.isPassedTheory;
        data["finalized"] = this.finalized;
        if (Array.isArray(this.experts)) {
            data["experts"] = [];
            for (let item of this.experts)
                data["experts"].push(item.toJSON());
        }
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IApplicantExamDetails {
    examId: string;
    date: moment.Moment;
    duration: number;
    reviewComment?: string | undefined;
    examPrice: number;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    examinationCenterName: string;
    address: string;
    qualificationEvaluationCenterName: string;
    city: string;
    examStatus: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification: boolean;
    examType: ExamType;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
    practicalPartDuration: number;
    practicalQuestionsCount: number;
    theoreticalPartDuration: number;
    theoreticalQuestionsCount: number;
    rules?: string | undefined;
    isPassedTheory?: boolean | undefined;
    finalized: boolean;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts: ExamExpert[];
    statusChangeTime: moment.Moment;
}

export class ApplicantExamList implements IApplicantExamList {
    items!: ApplicantExam[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IApplicantExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicantExam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ApplicantExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IApplicantExamList {
    items: ApplicantExam[];
    page: number;
    pageSize: number;
    total: number;
}

export class ApplicantIdentityDoc implements IApplicantIdentityDoc {
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;

    constructor(data?: IApplicantIdentityDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantIdentityDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantIdentityDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicantIdentityDoc {
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
}

/** Другой документ */
export class ApplicantOtherIdentity implements IApplicantOtherIdentity {
    /** название документа */
    title!: string;
    /** данные документа */
    data!: string;

    constructor(data?: IApplicantOtherIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApplicantOtherIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantOtherIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["data"] = this.data;
        return data; 
    }
}

/** Другой документ */
export interface IApplicantOtherIdentity {
    /** название документа */
    title: string;
    /** данные документа */
    data: string;
}

/** паспорт */
export class ApplicantPassport implements IApplicantPassport {
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;
    /** адрес регистрации */
    registrationAddress!: string;

    constructor(data?: IApplicantPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
            this.registrationAddress = _data["registrationAddress"];
        }
    }

    static fromJS(data: any): ApplicantPassport {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPassport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        data["registrationAddress"] = this.registrationAddress;
        return data; 
    }
}

/** паспорт */
export interface IApplicantPassport {
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
    /** адрес регистрации */
    registrationAddress: string;
}

export class ApplicantQualification implements IApplicantQualification {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;

    constructor(data?: IApplicantQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
        }
    }

    static fromJS(data: any): ApplicantQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        return data; 
    }
}

export interface IApplicantQualification {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
}

export class ApplicantQualificationDetails implements IApplicantQualificationDetails {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;
    examDate!: moment.Moment;
    occupationalStandardTitle!: string;
    qecFullName!: string;
    /** Секретный код НАРК */
    secretCode!: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl!: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl!: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;

    constructor(data?: IApplicantQualificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
            this.examDate = _data["examDate"] ? moment(_data["examDate"].toString()) : <any>undefined;
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qecFullName = _data["qecFullName"];
            this.secretCode = _data["secretCode"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.narkDocUrl = _data["narkDocUrl"];
            this.certificateUrl = _data["certificateUrl"];
        }
    }

    static fromJS(data: any): ApplicantQualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qecFullName"] = this.qecFullName;
        data["secretCode"] = this.secretCode;
        data["narkPageUrl"] = this.narkPageUrl;
        data["narkDocUrl"] = this.narkDocUrl;
        data["certificateUrl"] = this.certificateUrl;
        return data; 
    }
}

export interface IApplicantQualificationDetails {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
    examDate: moment.Moment;
    occupationalStandardTitle: string;
    qecFullName: string;
    /** Секретный код НАРК */
    secretCode: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
}

export class AuthResult implements IAuthResult {
    profile!: Applicant;
    token!: string;

    constructor(data?: IAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new Applicant();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? Applicant.fromJS(_data["profile"]) : new Applicant();
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthResult {
    profile: Applicant;
    token: string;
}

export class ChangePassword implements IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IChangePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePassword {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword: string;
    /** Новый пароль */
    newPassword: string;
}

export class CheckVerificationCode implements ICheckVerificationCode {
    captcha?: string | undefined;
    phone!: string;
    verificationCode!: string;

    constructor(data?: ICheckVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): CheckVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface ICheckVerificationCode {
    captcha?: string | undefined;
    phone: string;
    verificationCode: string;
}

export class ConfirmEmailByToken implements IConfirmEmailByToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: IConfirmEmailByToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailByToken {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailByToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface IConfirmEmailByToken {
    captcha?: string | undefined;
    token: string;
}

export class CreateExamApplication implements ICreateExamApplication {
    examId!: string;

    constructor(data?: ICreateExamApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
        }
    }

    static fromJS(data: any): CreateExamApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExamApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        return data; 
    }
}

export interface ICreateExamApplication {
    examId: string;
}

export enum DocumentType {
    Other = "other",
    IdentityDoc = "identityDoc",
    SecondaryEducationConfirmation = "secondaryEducationConfirmation",
    HigherEducationConfirmation = "higherEducationConfirmation",
    WorkExperienceConfirmation = "workExperienceConfirmation",
    ContinuingEducationConfirmation = "continuingEducationConfirmation",
    CertificateForExchange = "certificateForExchange",
    NoCriminalRecord = "noCriminalRecord",
    QualificationCertificate = "qualificationCertificate",
    ConsentToProcessingPersonalData = "consentToProcessingPersonalData",
}

export class EventsStateHolder implements IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IEventsStateHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): EventsStateHolder {
        data = typeof data === 'object' ? data : {};
        let result = new EventsStateHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;
}

export class Exam implements IExam {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;

    constructor(data?: IExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
        }
    }

    static fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        return data; 
    }
}

export interface IExam {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
}

export class ExamApplicationDetails implements IExamApplicationDetails {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam!: Exam;
    applicant!: Applicant;
    applicantIdentityDoc!: ApplicantIdentityDoc;
    documents!: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.exam = new Exam();
            this.applicant = new Applicant();
            this.applicantIdentityDoc = new ApplicantIdentityDoc();
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examSessionStatus = _data["examSessionStatus"];
            this.recommendations = _data["recommendations"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.processedByNark = _data["processedByNark"];
            this.examSessionReadyStatus = _data["examSessionReadyStatus"];
            this.exam = _data["exam"] ? Exam.fromJS(_data["exam"]) : new Exam();
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : new Applicant();
            this.applicantIdentityDoc = _data["applicantIdentityDoc"] ? ApplicantIdentityDoc.fromJS(_data["applicantIdentityDoc"]) : new ApplicantIdentityDoc();
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ExamApplicationDocument.fromJS(item));
            }
            this.reviewComment = _data["reviewComment"];
            this.agreementUrl = _data["agreementUrl"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.certificateUrl = _data["certificateUrl"];
            this.certificateDeliveryAddress = _data["certificateDeliveryAddress"];
            this.isPassedTheory = _data["isPassedTheory"];
            this.signCode = _data["signCode"];
            this.approveCode = _data["approveCode"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examSessionStatus"] = this.examSessionStatus;
        data["recommendations"] = this.recommendations;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["processedByNark"] = this.processedByNark;
        data["examSessionReadyStatus"] = this.examSessionReadyStatus;
        data["exam"] = this.exam ? this.exam.toJSON() : <any>undefined;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["applicantIdentityDoc"] = this.applicantIdentityDoc ? this.applicantIdentityDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["reviewComment"] = this.reviewComment;
        data["agreementUrl"] = this.agreementUrl;
        data["narkPageUrl"] = this.narkPageUrl;
        data["certificateUrl"] = this.certificateUrl;
        data["certificateDeliveryAddress"] = this.certificateDeliveryAddress;
        data["isPassedTheory"] = this.isPassedTheory;
        data["signCode"] = this.signCode;
        data["approveCode"] = this.approveCode;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationDetails {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam: Exam;
    applicant: Applicant;
    applicantIdentityDoc: ApplicantIdentityDoc;
    documents: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamApplicationDocument implements IExamApplicationDocument {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    documentDescription!: string;
    variant!: number;
    type!: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId!: string;
    applicantId!: string;
    submissionDate!: moment.Moment;
    readonly sourceFiles!: SourceFile[];

    constructor(data?: IExamApplicationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.documentDescription = _data["documentDescription"];
            this.variant = _data["variant"];
            this.type = _data["type"];
            this.documentTemplateId = _data["documentTemplateId"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicantId = _data["applicantId"];
            this.submissionDate = _data["submissionDate"] ? moment(_data["submissionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sourceFiles"])) {
                (<any>this).sourceFiles = [] as any;
                for (let item of _data["sourceFiles"])
                    (<any>this).sourceFiles!.push(SourceFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamApplicationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["documentDescription"] = this.documentDescription;
        data["variant"] = this.variant;
        data["type"] = this.type;
        data["documentTemplateId"] = this.documentTemplateId;
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sourceFiles)) {
            data["sourceFiles"] = [];
            for (let item of this.sourceFiles)
                data["sourceFiles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExamApplicationDocument {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    documentDescription: string;
    variant: number;
    type: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId: string;
    applicantId: string;
    submissionDate: moment.Moment;
    sourceFiles: SourceFile[];
}

export enum ExamApplicationStatus {
    Draft = "draft",
    InReview = "inReview",
    CorrectionsRequired = "correctionsRequired",
    PaymentRequired = "paymentRequired",
    Canceled = "canceled",
    Paid = "paid",
    AdmittedToExam = "admittedToExam",
    IsPassing = "isPassing",
    Absent = "absent",
    NotPassed = "notPassed",
    Passed = "passed",
}

export class ExamExpert implements IExamExpert {
    regNumber!: string;
    expertId!: string;
    fullName!: string;
    email!: string;
    phone!: string;
    region!: string;
    /** Эксперт доступен для подписи протокола */
    active!: boolean;
    /** Протокол пописан экспертом */
    signed!: boolean;
    chairman!: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;

    constructor(data?: IExamExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regNumber = _data["regNumber"];
            this.expertId = _data["expertId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.region = _data["region"];
            this.active = _data["active"];
            this.signed = _data["signed"];
            this.chairman = _data["chairman"];
            this.acceptedInvite = _data["acceptedInvite"];
            this.position = _data["position"];
            this.signedCode = _data["signedCode"];
        }
    }

    static fromJS(data: any): ExamExpert {
        data = typeof data === 'object' ? data : {};
        let result = new ExamExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNumber"] = this.regNumber;
        data["expertId"] = this.expertId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["region"] = this.region;
        data["active"] = this.active;
        data["signed"] = this.signed;
        data["chairman"] = this.chairman;
        data["acceptedInvite"] = this.acceptedInvite;
        data["position"] = this.position;
        data["signedCode"] = this.signedCode;
        return data; 
    }
}

export interface IExamExpert {
    regNumber: string;
    expertId: string;
    fullName: string;
    email: string;
    phone: string;
    region: string;
    /** Эксперт доступен для подписи протокола */
    active: boolean;
    /** Протокол пописан экспертом */
    signed: boolean;
    chairman: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;
}

export enum ExamReviewStatus {
    All = "all",
    Applying = "applying",
    Recorded = "recorded",
}

export enum ExamSessionReadyStatuses {
    WaitingForStart = "waitingForStart",
    ExamIsPassing = "examIsPassing",
    TheoreticalExamIsPassingAndSessionStarted = "theoreticalExamIsPassingAndSessionStarted",
    ExamSessionTimeout = "examSessionTimeout",
    PracticalExamIsPassingAndSessionStarted = "practicalExamIsPassingAndSessionStarted",
    ExamFinished = "examFinished",
    SessionFinished = "sessionFinished",
}

export enum ExamSessionStatus {
    Active = "active",
    Completed = "completed",
}

export enum ExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    Canceled = "canceled",
    IsPassing = "isPassing",
    Finishing = "finishing",
    Finished = "finished",
    FinalizedResults = "finalizedResults",
    NokProtocolSigned = "nokProtocolSigned",
    AkProtocolSigned = "akProtocolSigned",
    SovietProtocolSignedByMembers = "sovietProtocolSignedByMembers",
    SovietProtocolSignedByChairman = "sovietProtocolSignedByChairman",
}

export enum ExamType {
    Intramural = "intramural",
    Recertification = "recertification",
    Online = "online",
}

export class GeneratePaymentUrl implements IGeneratePaymentUrl {
    examApplicationId!: string;

    constructor(data?: IGeneratePaymentUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examApplicationId = _data["examApplicationId"];
        }
    }

    static fromJS(data: any): GeneratePaymentUrl {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePaymentUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examApplicationId"] = this.examApplicationId;
        return data; 
    }
}

export interface IGeneratePaymentUrl {
    examApplicationId: string;
}

export enum IdentityDocType {
    Passport = "passport",
    Other = "other",
}

export class LoginApplicant implements ILoginApplicant {
    captcha?: string | undefined;
    phone!: string;
    password!: string;

    constructor(data?: ILoginApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginApplicant {
        data = typeof data === 'object' ? data : {};
        let result = new LoginApplicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginApplicant {
    captcha?: string | undefined;
    phone: string;
    password: string;
}

export enum MyExamStatus {
    All = "all",
    Approved = "approved",
    Processing = "processing",
    Recorded = "recorded",
    Canceled = "canceled",
}

export class QualificationDocumentTemplate implements IQualificationDocumentTemplate {
    /** Идентификатор шаблона */
    readonly id!: string;
    /** Порядок в списке */
    readonly order!: number;
    /** Вариант */
    readonly variant!: number;
    /** Описание */
    readonly description!: string;
    type!: DocumentType;

    constructor(data?: IQualificationDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).order = _data["order"];
            (<any>this).variant = _data["variant"];
            (<any>this).description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): QualificationDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["variant"] = this.variant;
        data["description"] = this.description;
        data["type"] = this.type;
        return data; 
    }
}

export interface IQualificationDocumentTemplate {
    /** Идентификатор шаблона */
    id: string;
    /** Порядок в списке */
    order: number;
    /** Вариант */
    variant: number;
    /** Описание */
    description: string;
    type: DocumentType;
}

export class QualificationDocumentTemplateGroup implements IQualificationDocumentTemplateGroup {
    title!: string;
    description!: string;
    order!: number;
    hasVariants!: boolean;
    templates!: QualificationDocumentTemplate[];

    constructor(data?: IQualificationDocumentTemplateGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.hasVariants = _data["hasVariants"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(QualificationDocumentTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationDocumentTemplateGroup {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDocumentTemplateGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["order"] = this.order;
        data["hasVariants"] = this.hasVariants;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQualificationDocumentTemplateGroup {
    title: string;
    description: string;
    order: number;
    hasVariants: boolean;
    templates: QualificationDocumentTemplate[];
}

export class RegisterApplicant implements IRegisterApplicant {
    captcha?: string | undefined;
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName!: string;
    /** Номер телефона */
    phone!: string;
    /** Пароль */
    password!: string;
    sex!: Sex;
    /** Адрес электронной почты */
    email!: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    /** Код верификации */
    verificationCode!: string;

    constructor(data?: IRegisterApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.sex = _data["sex"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): RegisterApplicant {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterApplicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["sex"] = this.sex;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IRegisterApplicant {
    captcha?: string | undefined;
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName: string;
    /** Номер телефона */
    phone: string;
    /** Пароль */
    password: string;
    sex: Sex;
    /** Адрес электронной почты */
    email: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    /** Код верификации */
    verificationCode: string;
}

export class ResetPassword implements IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode!: string;
    /** Номер телефона соискателя */
    phone!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IResetPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.verificationCode = _data["verificationCode"];
            this.phone = _data["phone"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPassword {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["verificationCode"] = this.verificationCode;
        data["phone"] = this.phone;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode: string;
    /** Номер телефона соискателя */
    phone: string;
    /** Новый пароль */
    newPassword: string;
}

export class SendCodeToSignApplication implements ISendCodeToSignApplication {
    captcha?: string | undefined;

    constructor(data?: ISendCodeToSignApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendCodeToSignApplication {
        data = typeof data === 'object' ? data : {};
        let result = new SendCodeToSignApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendCodeToSignApplication {
    captcha?: string | undefined;
}

export class SendConfirmationEmailAgain implements ISendConfirmationEmailAgain {
    captcha?: string | undefined;

    constructor(data?: ISendConfirmationEmailAgain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendConfirmationEmailAgain {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationEmailAgain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendConfirmationEmailAgain {
    captcha?: string | undefined;
}

export class SendVerificationCode implements ISendVerificationCode {
    captcha?: string | undefined;
    /** Телефон соискателя */
    phone!: string;

    constructor(data?: ISendVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SendVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ISendVerificationCode {
    captcha?: string | undefined;
    /** Телефон соискателя */
    phone: string;
}

export class SendVerificationCodeForUpdatePhone implements ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    /** Телефон соискателя */
    phone!: string;
    /** Пароль */
    password!: string;

    constructor(data?: ISendVerificationCodeForUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SendVerificationCodeForUpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCodeForUpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    /** Телефон соискателя */
    phone: string;
    /** Пароль */
    password: string;
}

export class SetApplicantOtherIdentity implements ISetApplicantOtherIdentity {
    /** название документа */
    title!: string;
    /** данные документа */
    data!: string;

    constructor(data?: ISetApplicantOtherIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): SetApplicantOtherIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicantOtherIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["data"] = this.data;
        return data; 
    }
}

export interface ISetApplicantOtherIdentity {
    /** название документа */
    title: string;
    /** данные документа */
    data: string;
}

export class SetApplicantPassport implements ISetApplicantPassport {
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;
    /** адрес регистрации */
    registrationAddress!: string;

    constructor(data?: ISetApplicantPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
            this.registrationAddress = _data["registrationAddress"];
        }
    }

    static fromJS(data: any): SetApplicantPassport {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicantPassport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        data["registrationAddress"] = this.registrationAddress;
        return data; 
    }
}

export interface ISetApplicantPassport {
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
    /** адрес регистрации */
    registrationAddress: string;
}

export enum Sex {
    Male = "male",
    Female = "female",
}

export class SourceFile implements ISourceFile {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    fileName?: string | undefined;

    constructor(data?: ISourceFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SourceFile {
        data = typeof data === 'object' ? data : {};
        let result = new SourceFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface ISourceFile {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    fileName?: string | undefined;
}

export class SubmitExamApplication implements ISubmitExamApplication {
    captcha?: string | undefined;
    signCode!: string;
    certificateDeliveryAddress!: string;

    constructor(data?: ISubmitExamApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.signCode = _data["signCode"];
            this.certificateDeliveryAddress = _data["certificateDeliveryAddress"];
        }
    }

    static fromJS(data: any): SubmitExamApplication {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitExamApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["signCode"] = this.signCode;
        data["certificateDeliveryAddress"] = this.certificateDeliveryAddress;
        return data; 
    }
}

export interface ISubmitExamApplication {
    captcha?: string | undefined;
    signCode: string;
    certificateDeliveryAddress: string;
}

export class UpdatePhone implements IUpdatePhone {
    /** Номер телефона */
    phone!: string;
    /** Код верификации */
    verificationCode!: string;

    constructor(data?: IUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): UpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IUpdatePhone {
    /** Номер телефона */
    phone: string;
    /** Код верификации */
    verificationCode: string;
}

export class UpdateProfile implements IUpdateProfile {
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName!: string;
    /** Адрес электронной почты */
    email!: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    sex!: Sex;

    constructor(data?: IUpdateProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
        }
    }

    static fromJS(data: any): UpdateProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        return data; 
    }
}

export interface IUpdateProfile {
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName: string;
    /** Адрес электронной почты */
    email: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    sex: Sex;
}

export class VerificationCodeSendingStatus implements IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;

    constructor(data?: IVerificationCodeSendingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasSent = _data["wasSent"];
            this.waitingSeconds = _data["waitingSeconds"];
        }
    }

    static fromJS(data: any): VerificationCodeSendingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationCodeSendingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasSent"] = this.wasSent;
        data["waitingSeconds"] = this.waitingSeconds;
        return data; 
    }
}

export interface IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class ApiClient extends ApiClientBase {
    private http2: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl2: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(baseUrl, http);
        this.http2 = http ? http : <any>window;
        this.baseUrl2 = baseUrl ? baseUrl : "";
    }

    uploadExamApplicationDocumentFix(examApplicationId: string, templateId: string, file: File): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl2 + "/api/v1/exam-applications/{examApplicationId}/documents/{templateId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter ‘file’ cannot be null.");
        else
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadExamApplicationDocument(_response);
        });
    }
}